import { SectionSeparator } from '@styles/layout';
import { HotelContent } from '@model/iceberg/hotel-content';
import { useI18NextContext } from '@components/hooks';
import { SectionTitle, ContentTabs } from '@components/common';
import { TestId } from '@components/test-ids';
import { HotelInformation } from './HotelInformation';
import { Theme } from '@theme/base';
import { useTheme } from '@emotion/react';

export interface HotelInformationPanelProps {
  hotels: Array<HotelContent>;
}

/* ***************** *
 *       Styles      *
 * ***************** */
const swipeStyles: (theme: Theme) => any = (theme: Theme) => ({
  padding: theme.custom.spacing.medium,
  marginTop: '-29px',
  border: `1px solid ${theme.custom.colors.group10.light}`,
  borderRadius: '0px 0px 10px 10px'
});

export const HotelInformationPanel = ({ hotels }: HotelInformationPanelProps) => {
  const t: any = useI18NextContext();
  const theme: Theme = useTheme();
  const getHotelLabs = (hotels: Array<HotelContent>) => hotels.map(({ place }) => place.hotel?.display || '');

  const getHotelPanels = (hotels: Array<HotelContent>) =>
    hotels.map((hotel) => <HotelInformation key={hotel.connectId} hotel={hotel} />);

  const getToggleLabels = (fn: any, labels: Array<string>) =>
    labels.map((label) => fn('product__hotel-information--button', { name: label }));

  const labels = getHotelLabs(hotels);

  return (
    <div data-testid={TestId.hotelInformation.main}>
      <SectionTitle heading={'product__hotel-information--title'} />
      <ContentTabs
        tabLabels={labels}
        toggleLabels={getToggleLabels(t, labels)}
        showToggleIcons
        canScroll={labels.length > 3}
        swipeableStyles={swipeStyles(theme)}
      >
        {getHotelPanels(hotels)}
      </ContentTabs>
      <SectionSeparator />
    </div>
  );
};
